import types from "./types";

const initialState = {
  fetchingProgramInfo: false,
  programInfo: {},
  fetchingProgramInfoError: null,

  isProgramCreating: false,
  createdProgram: null,
  programCreatingError: "",

  isProgramUpdating: false,
  updatedProgram: null,
  programUpdatingError: "",

  fetchingAllProgramBlock: false,
  allProgramBlock: [],
  fetchingAllProgramBlockError: null,

  fetchingAddProgramBlock: false,
  createdProgramBlock: null,
  fetchingAddProgramBlockError: null,

  fetchingUpdateProgramBlock: false,
  updatedProgramBlock: null,
  fetchingUpdateProgramBlockError: null,

  fetchingDeleteProgramBlock: false,
  deletedProgramBlock: null,
  fetchingProgramBlockError: null,

  fetchingAllProgramModule: false,
  allProgramModule: [],
  fetchingAllProgramModuleError: null,

  fetchingAddProgramModule: false,
  createdProgramModule: null,
  fetchingAddProgramModuleError: null,

  fetchingUpdateProgramModule: false,
  updatedProgramModule: null,
  fetchingUpdateProgramModuleError: null,

  fetchingDeleteProgramModule: false,
  deletedProgramModule: null,
  fetchingProgramModuleError: null,

  changingProgramStatus: false,
  changedProgramStatus: null,
  changingProgramStatusError: "",

  fetchingProgramAuthors: false,
  programAuthors: [],
  fetchingProgramAuthorsError: "",

  changingProgramAuthors: false,
  changedProgramAuthors: null,
  changingProgramAuthorsError: "",
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_BLOCK_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingAllProgramBlock: action.fetchingAddProgramBlock
      }

    case types.GET_ALL_BLOCK_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingAllProgramBlock: action.fetchingAllProgramBlock,
        allProgramBlock: action.allProgramBlock
      }

    case types.GET_ALL_BLOCK_PROGRAM_ERROR:
      return {
        ...state,
        fetchingAllProgramBlock: action.fetchingAllProgramBlock,
        fetchingAllProgramBlockError: action.fetchingAllProgramBlockError
      }

    case types.GET_ALL_MODULE_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingAllProgramModule: action.fetchingAddProgramModule
      }

    case types.GET_ALL_MODULE_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingAllProgramModule: action.fetchingAllProgramModule,
        allProgramModule: action.allProgramModule
      }

    case types.GET_ALL_MODULE_PROGRAM_ERROR:
      return {
        ...state,
        fetchingAllProgramModule: action.fetchingAllProgramModule,
        fetchingAllProgramModuleError: action.fetchingAllProgramModuleError
      }

    case types.CHANGE_PROGRAM_INFORMATION:
      return {
        ...state,
        programInfo: action.programInfo
      };

    case types.CREATE_CONSTRUCTOR_PROGRAM_REQUEST:
      return {
        ...state,
        isProgramCreating: action.isProgramCreating
      };
    case types.CREATE_CONSTRUCTOR_PROGRAM_COMPLETED:
      return {
        ...state,
        isProgramCreating: action.isProgramCreating,
        createdProgram: action.createdProgram
      };
    case types.CREATE_CONSTRUCTOR_PROGRAM_ERROR:
      return {
        ...state,
        isProgramCreating: action.isProgramCreating,
        programCreatingError: action.programCreatingError
      };

    case types.UPDATE_CONSTRUCTOR_PROGRAM_REQUEST:
      return {
        ...state,
        isProgramUpdating: action.isProgramUpdating
      };
    case types.UPDATE_CONSTRUCTOR_PROGRAM_COMPLETED:
      return {
        ...state,
        isProgramUpdating: action.isProgramUpdating,
        updatedProgram: action.updatedProgram
      };
    case types.UPDATE_CONSTRUCTOR_PROGRAM_ERROR:
      return {
        ...state,
        isProgramUpdating: action.isProgramUpdating,
        programUpdatingError: action.programUpdatingError
      };

    case types.CREATE_BLOCK_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingAddProgramBlock: action.fetchingAddProgramBlock
      }
    case types.CREATE_BLOCK_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingAddProgramBlock: action.fetchingAddProgramBlock,
        createdProgramBlock: action.createdProgramBlock
      }
    case types.CREATE_BLOCK_PROGRAM_ERROR:
      return {
        ...state,
        fetchingAddProgramBlock: action.fetchingAddProgramBlock,
        fetchingAddProgramBlockError: action.fetchingAddProgramBlockError
      }

    case types.UPDATE_BLOCK_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingUpdateProgramBlock: action.fetchingUpdateProgramBlock
      }
    case types.UPDATE_BLOCK_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingUpdateProgramBlock: action.fetchingUpdateProgramBlock,
        updatedProgramBlock: action.updatedProgramBlock
      }
    case types.UPDATE_BLOCK_PROGRAM_ERROR:
      return {
        ...state,
        fetchingUpdateProgramBlock: action.fetchingUpdateProgramBlock,
        fetchingUpdateProgramBlockError: action.fetchingUpdateProgramBlockError
      }

    case types.DELETE_BLOCK_PROGRAM_REQUEST:
      return {
        ...state,
        fetchingDeleteProgramBlock: action.fetchingDeleteProgramBlock
      }
    case types.DELETE_BLOCK_PROGRAM_COMPLETED:
      return {
        ...state,
        fetchingDeleteProgramBlock: action.fetchingDeleteProgramBlock,
        deletedProgramBlock: action.deletedProgramBlock
      }
    case types.DELETE_BLOCK_PROGRAM_ERROR:
      return {
        ...state,
        fetchingDeleteProgramBlock: action.fetchingDeleteProgramBlock,
        fetchingDeleteProgramBlockError: action.fetchingDeleteProgramBlockError
      }

    case types.SEND_PROGRAM_APPROVE_REQUEST:
      return {
        ...state,
        changingProgramStatus: action.changingProgramStatus,
      }
    case types.SEND_PROGRAM_APPROVE_COMPLETED:
      return {
        ...state,
        changingProgramStatus: action.changingProgramStatus,
        changedProgramStatus: action.changedProgramStatus
      }
    case types.SEND_PROGRAM_APPROVE_ERROR:
      return {
        ...state,
        changingProgramStatus: action.changingProgramStatus,
        changingProgramStatusError: action.changingProgramStatusError
      }

    case types.GET_PROGRAM_AUTHORS_REQUEST:
      return {
        ...state,
        fetchingProgramAuthors: action.fetchingProgramAuthors,
      }
    case types.GET_PROGRAM_AUTHORS_COMPLETED:
      return {
        ...state,
        fetchingProgramAuthors: action.fetchingProgramAuthors,
        programAuthors: action.programAuthors
      }
    case types.GET_PROGRAM_AUTHORS_ERROR:
      return {
        ...state,
        fetchingProgramAuthors: action.fetchingProgramAuthors,
        fetchingProgramAuthorsError: action.fetchingProgramAuthorsError
      }

    case types.SEND_PROGRAM_AUTHORS_REQUEST:
      return {
        ...state,
        changingProgramAuthors: action.changingProgramAuthors,
      }
    case types.SEND_PROGRAM_AUTHORS_COMPLETED:
      return {
        ...state,
        changingProgramAuthors: action.changingProgramAuthors,
        changedProgramAuthors: action.changedProgramAuthors
      }
    case types.SEND_PROGRAM_AUTHORS_ERROR:
      return {
        ...state,
        changingProgramAuthors: action.changingProgramAuthors,
        changingProgramAuthorsError: action.changingProgramAuthorsError
      }

    default:
      return state;
  }
};
